import React from "react";

const ClavePasa = props => {
	return (
		<div className="clave">
			<p className="claveApta" style={{ color: "#5F5F5F" }}>
				En gris, no pasan a semifinales
			</p>
		</div>
	);
};

export default ClavePasa;



// WEBPACK FOOTER //
// ./src/components/ClavePasa.js